let stopNotifications = null;

function initNotifications() {
  if (stopNotifications) stopNotifications();
  const root = document.getElementById('system-notifications');
  if (!root) return;
  const menu = root.querySelector('.notifications');
  const badge = root.querySelector('#notification-number');
  const bell = root.querySelector('[data-bs-toggle="dropdown"]');
  const toast = root.querySelector('.system-notification-toast');
  const abort = new AbortController();
  const pending = new Set(), shown = new Set();
  let stopped = false, busy = false, dirty = false, timer, toastTimer, failures = 0, bulkPending = false, latestKnownId = 0;
  const node = (tag, value, className) => {
    const element = document.createElement(tag);
    if (value != null) element.textContent = value;
    if (className) element.className = className;
    return element;
  };
  function render(data) {
    if (toast.dataset.notificationId && !data.items.some(item => String(item.id) === toast.dataset.notificationId)) toast.hidden = true;
    badge.textContent = data.count;
    bell.setAttribute('aria-label', `Notificaciones: ${data.count} sin leer`);
    const header = node('li', null, 'dropdown-header');
    header.append(document.createTextNode(`Tienes ${data.count} nuevas notificaciones `));
    const all = node('a'); all.href = root.dataset.allUrl;
    all.append(node('span', 'Ver todas', 'badge rounded-pill bg-primary p-2 ms-2')); header.append(all);
    const children = [header];
    data.items.slice(0, 10).forEach(item => {
      const divider = node('li'); divider.append(node('hr', null, 'dropdown-divider'));
      const row = node('li', null, 'bg-info-light');
      const link = node('a', null, 'notification-item notification-destination text-decoration-none text-reset');
      link.href = item.url; link.dataset.notificationId = item.id;
      link.append(node('i', null, `bi ${item.icon || 'bi-bell'} ${item.icon_class || ''}`));
      const body = node('div'); body.append(node('p', item.title, 'text-start'));
      body.append(node('small', item.description, 'small'), node('br'));
      body.append(node('small', new Date(item.created_at).toLocaleString('es'), 'fst-italic'));
      link.append(body); row.append(link); children.push(divider, row);
    });
    if (!data.items.length) children.push(node('li', 'No tienes notificaciones pendientes.', 'px-3 py-3 text-muted small'));
    menu.replaceChildren(...children);
  }
  function showToast(item) {
    if (document.hidden || shown.has(item.id)) return;
    shown.add(item.id); if (shown.size > 200) shown.delete(shown.values().next().value);
    toast.textContent = `Nueva notificación: ${item.title}`; toast.href = item.url; toast.dataset.notificationId = item.id; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 7000);
  }
  async function refresh() {
    if (stopped) return;
    if (busy) { dirty = true; return; }
    busy = true;
    const requestedIds = new Set(pending), requestedBulk = bulkPending;
    bulkPending = false;
    try {
      const response = await fetch(root.dataset.previewUrl, { credentials: 'same-origin', signal: abort.signal, headers: { Accept: 'application/json' } });
      if (response.status === 401 || response.status === 403 || response.redirected) {
        render({ count: 0, items: [] }); toast.hidden = true; stopped = true; return;
      }
      if (!response.ok) throw new Error('No se pudieron sincronizar las notificaciones.');
      const data = await response.json();
      if (stopped) return;
      failures = 0; render(data);
      const newest = data.items.find(item => requestedIds.has(Number(item.id)) || (requestedBulk && Number(item.id) > latestKnownId));
      if (newest) showToast(newest);
      latestKnownId = Math.max(latestKnownId, ...data.items.map(item => Number(item.id)));
      requestedIds.forEach(id => pending.delete(id));
    } catch (error) {
      if (!stopped && error.name !== 'AbortError' && ++failures <= 3) {
        if (requestedBulk) bulkPending = true;
        clearTimeout(timer); timer = setTimeout(refresh, 1000 * Math.pow(2, failures - 1));
      }
    } finally {
      busy = false;
      if (!stopped && dirty) { dirty = false; schedule(); }
    }
  }
  function schedule() {
    if (stopped) return;
    clearTimeout(timer); timer = setTimeout(refresh, 250);
  }
  function changed(event) {
    const data = event.detail || {};
    if (Number(data.user_id) !== Number(root.dataset.userId)) return;
    if (data.kind === 'created') {
      if (data.id) pending.add(Number(data.id));
      else bulkPending = true;
      if (pending.size > 200) pending.delete(pending.values().next().value);
    }
    schedule();
  }
  function visibility() { if (!document.hidden) schedule(); }
  document.addEventListener('uni:notifications:changed', changed);
  document.addEventListener('uni:notifications:connected', schedule);
  document.addEventListener('visibilitychange', visibility);
  bell.addEventListener('click', schedule);
  refresh();
  stopNotifications = () => {
    stopped = true; abort.abort(); clearTimeout(timer); clearTimeout(toastTimer); toast.hidden = true;
    document.removeEventListener('uni:notifications:changed', changed);
    document.removeEventListener('uni:notifications:connected', schedule);
    document.removeEventListener('visibilitychange', visibility);
    bell.removeEventListener('click', schedule); stopNotifications = null;
  };
}
document.addEventListener('turbolinks:load', initNotifications);
document.addEventListener('turbolinks:before-cache', () => { if (stopNotifications) stopNotifications(); });
